<template>
    <div
        class="tw-absolute xs:tw-top-3 xs:tw-left-3 lg:tw--top-8 lg:tw--left-0 tw-font-medium tw-text-gray-500"
    >
        Schritt {{ step }} von {{ totalSteps }}
    </div>
</template>

<script>
export default {
    name: "AcquisitionFormProgress",

    props: {
        step: {
            type: Number,
            required: true,
        },
        totalSteps: {
            type: Number,
            required: true,
        },
    },
}
</script>

<style scoped>

</style>